import prodClient from 'client/prod';
import messages from 'messages/ko.ton.json';

prodClient(messages);
